import ChannelwillApi from '@/api/request-v2/channelwill'

export async function getChannelwillSign() {
  const {
    data: { sign, sign_time },
  } = await ChannelwillApi.generateAuthSignature()
  return { sign, sign_time }
}
